export default __webpack_public_path__ + "static/media/tender2.1404150a.png";